import { HttpService } from "@/core";
import { TenantInfo, SetPwdReq, ChangePwdReq, FeedbackReq } from "./join.interface";
import { message, Modal } from "ant-design-vue";
import { IsZhiHuiXingHe } from "@/core/hooks/SetTheme";
export class JoinService {
  static useSetPasswordApi() {
    const api = (data: SetPwdReq) =>
      HttpService.axios({
        method: "POST",
        url: "/auth/inviteTenantUserSetPassword",
        data,
      });
    return HttpService.useRequest<void>(api, {
      isOutError: true,
      onError: (e) => {
        message.error(e.message);
      },
    });
  }

  static useChangePasswordApi() {
    const api = (data: ChangePwdReq) =>
      HttpService.axios({
        method: "POST",
        url: "/auth/tenantUserSetPassword",
        data,
      });
    return HttpService.useRequest<void>(api, {
      isOutError: true,
      onError: (e) => {
        message.error(e.message);
      },
    });
  }

  static useFeedbackApi() {
    const api = (data: FeedbackReq) =>
      HttpService.backstageAxios({
        method: "POST",
        url: "/feedback",
        data,
      });
    return HttpService.useRequest<void>(api, {
      isOutError: true,
      onError: (e) => {
        message.error(e.message);
      },
    });
  }

  /**
   * 退出团队
   */
  static useQuitApi() {
    const api = (signature: string) =>
      HttpService.axios({
        method: "PUT",
        url: "/tenant_user/rejectInvite",
        data: { signature },
      });
    return HttpService.useRequest<void>(api, {
      isOutError: true,
      onError: (e) => {
        message.error(e.message);
      },
    });
  }

  /**
   * 签名换取租户信息
   */
  static useParseSignatureApi() {
    const api = (signature: string) =>
      HttpService.axios({
        method: "POST",
        url: "/auth/inviteTenantUserSignatureDetail",
        data: { signature },
      });
    return HttpService.useRequest<TenantInfo>(api, {
      isOutError: true,
      onError: (e) => {
        message.error(e.message);
      },
    });
  }

  /**
   * 获取验证码
   */
  static useGetValidCode() {
    const api = (mobile: string, bizType: string) => {
      return HttpService.axios({
        method: "GET",
        url: "/verification_code",
        params: { mobile, bizType, loginSource: IsZhiHuiXingHe() ? "zhxh" : "hhr" },
      });
    };

    return HttpService.useRequest<void>(api, {
      isOutError: true,
      onError: (e) => {
        message.error(e.message);
      },
    });
  }

  /**
   * 获取验证码
   */
  static useCheckValidCode() {
    const api = (mobile: string, bizType: string, code: string) =>
      HttpService.axios({
        method: "GET",
        url: "/verification_code/verify",
        params: { mobile, bizType, code },
      });
    return HttpService.useRequest<void>(api, {
      isOutError: true,
      onError: (e) => {
        // message.error(e.message);系统异常，攻城狮正在努力抢修中，一会儿就好了！
        message.error("系统异常，攻城狮正在努力抢修中，一会儿就好了！");
      },
    });
  }
  /**
   * 巡检详情
   */
  static getDetail() {
    const api = (id) =>
      HttpService.axios({
        url: `/patrol_inspections/${id}`,
        method: "GET",
      });
    return HttpService.useRequest<void>(api, {
      isOutError: true,
      onError: (e) => {
        message.error(e.message);
      },
    });
  }

  /**
   * 获取图片临时路径
   */
  static generateSignUrl() {
    const api = (data) =>
      HttpService.axios({
        method: "POST",
        url: "/v1/oss/get",
        data,
      });
    return HttpService.useRequest<void>(api, {
      isOutError: true,
      onError: (e) => {
        message.error(e.message);
      },
    });
  }
}
